import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material'

import FileInput from 'src/Component/FileInput'
import InputField from 'src/Component/InputField'

import SimpleModal from 'src/Component/SimpleModal'
import useAddHook from './useAddHook'
import { Controller } from 'react-hook-form'

type AddParentGymModalProps = {
  open: boolean
  onClose: () => void
  successCallback: () => void
}
const AddParentGymModal = ({ open, onClose, successCallback }: AddParentGymModalProps) => {
  const { file, handleFileChange, control, errors, onSubmit, isLoadingAddParentGym } = useAddHook({
    successCallback,
  })
  return (
    <Box>
      <SimpleModal open={open} onClose={onClose}>
        <form onSubmit={onSubmit}>
          <Box>
            <FileInput
              type='image'
              title='You can click me to upload files!'
              discription='Support for  image file formats (.png, .jpeg)'
              name='fileuplaod'
              value={file}
              onChange={handleFileChange}
              showPreview
            />

            <Grid container mt={3}>
              <Grid xs={8} mb={2}>
                <Controller
                  name='name'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Name'
                        placeholder='Enter gym name'
                        value={field.value}
                        onChange={field.onChange}
                        error={!!errors.name}
                        required
                      />
                      {!!errors.name && (
                      <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                          {errors.name.message}
                        </Typography>
                      </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Button variant='contained' color='primary' type='submit' disabled={isLoadingAddParentGym}>
              {isLoadingAddParentGym ? <CircularProgress size={25} color='error' /> : 'SAVE'}
            </Button>
          </Box>
        </form>
      </SimpleModal>
    </Box>
  )
}

export default AddParentGymModal
